import NeighborhoodPage from "@/components/NeighborhoodPage";
import heroImage from "@/assets/hero-barra-da-tijuca.jpg?w=640;1024;1600;1920&format=avif;webp;jpg&as=picture";

const BarraDaTijuca = () => (
  <NeighborhoodPage
    name="Barra da Tijuca"
    slug="barra-da-tijuca"
    description="A região mais valorizada da Zona Oeste com praias, shoppings e condomínios de alto padrão. Encontre o imóvel dos seus sonhos na Barra."
    heroPicture={heroImage}
    featuredPages={[
      {
        title: "Cobertura Duplex com Piscina Privativa no Parque das Rosas",
        description: "3 quartos · 2 suítes · 140m² · Andar alto · Piscina privativa e churrasqueira",
        price: "R$ 1.600.000",
        route: "/barra-da-tijuca/cobertura-3-quartos-barra-parque-das-rosas",
        image: "https://cobertura-3-quartos-barra-parque-das-rosas.lovable.app/assets/piscina-vista-cobertura-Dy9_-Tuc.jpg",
      },
    ]}
  />
);

export default BarraDaTijuca;
